export default __webpack_public_path__ + "media/color/xp-444ff1dd.svg";